// extracted by mini-css-extract-plugin
export default {"sideLinks":"styles_sideLinks__i3lWP","link":"styles_link__XrKh2","active":"styles_active__XsTvk"};